export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";
export const CODE_SENT_ON_EMAIL = "CODE_SENT_ON_EMAIL";
export const VERIFY_CODE = "VERIFY_CODE";
export const VERIFY_CODE_FAILED = "VERIFY_CODE_FAILED";
export const VERIFY_CODE_SUCCESS = "VERIFY_CODE_SUCCESS";
export const CHANGE_PASSWORD_AFTER_CODE_VERIFY = "CHANGE_PASSWORD_AFTER_CODE_VERIFY";